export const NOTES_PLACEHOLDER = "Какой хотим результат? Детали. Блокеры.";
